import request from '@/utils/request'

/**
 * 根据病位、病性或者证候id查询
 * @param id 病位、病性或者证候id
 * @returns {AxiosPromise}
 */
export function getById(id) {
  return request({
    url: `/RelationSymptomSyndrome/getById/${id}`,
    method: 'post'
  })
}
